import { z } from 'zod';
import { UnixTimestamp } from '@triedge/domain-core/types';
import { NotificationTypeSchema } from '../types/enums';

export const PortalNotificationSchema = z.object({
  id: z.string(),
  message: z.string(),
  type: NotificationTypeSchema,
  createdAt: UnixTimestamp,
  readAt: UnixTimestamp.nullable().optional(),
});
export type PortalNotification = z.infer<typeof PortalNotificationSchema>;
